import React from 'react';

/**
 * Custom High-Fidelity Grocery Icon
 * Featuring a 3D Milk Carton, Honey Jar, Swiss Cheese, and Green Cup
 * Matching user uploaded design exactly.
 */
export const GroceryIcon = ({ size = 24, ...props }) => (
    <svg
        viewBox="0 0 100 100"
        width={size}
        height={size}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* --- Background Honey/Sauce Jar --- */}
        <g id="honey-jar">
            {/* Wooden Lid */}
            <rect x="48" y="21" width="14" height="6" rx="1" fill="#EDC4A7" />
            <line x1="48" y1="24" x2="62" y2="24" stroke="#DDB396" strokeWidth="1" />
            
            {/* Jar Body (Terracotta/Orange-Brown) */}
            <path
                d="M 49 27 
                   C 49 31, 44 34, 44 39 
                   C 44 49, 66 49, 66 39 
                   C 66 34, 61 31, 61 27 Z"
                fill="#E8927C"
            />
            {/* Jar Highlights */}
            <circle cx="56" cy="37" r="3" fill="#FFFFFF" opacity="0.3" />
            <circle cx="59" cy="41" r="1.5" fill="#FFFFFF" opacity="0.3" />
        </g>

        {/* --- 3D Milk Carton (Left) --- */}
        <g id="milk-carton">
            {/* Top flap/crease (Side) */}
            <polygon points="29,24 29,19 35,13 37,15" fill="#A0AEC0" />
            {/* Top flap/crease (Front) */}
            <polygon points="17,24 29,24 29,19 17,19" fill="#CBD5E0" />

            {/* Slanted top (Side) */}
            <polygon points="34,38 29,24 37,15 42,28" fill="#718096" />
            {/* Slanted top (Front) */}
            <polygon points="12,38 34,38 29,24 17,24" fill="#E2E8F0" />
            <circle cx="19" cy="31" r="1.5" fill="#FFFFFF" />
            <circle cx="23" cy="34" r="1" fill="#FFFFFF" />

            {/* Side face (Depth) */}
            <polygon points="34,38 42,28 42,64 34,74" fill="#CBD5E0" />
            
            {/* Front face (Main) */}
            <rect x="12" y="38" width="22" height="36" rx="1.5" fill="#E2E8F0" />

            {/* Red front label */}
            <rect x="12" y="45" width="22" height="22" fill="#E53E3E" />
            
            {/* Milk teardrop on label */}
            <path
                d="M 23 62 
                   C 19 58, 17 55, 17 52 
                   A 5 5 0 1 1 28 52 
                   C 28 55, 26 58, 23 62 Z"
                fill="#FFFFFF"
            />
            {/* Carton shadow at bottom */}
            <path d="M 12 72 L 34 72 L 34 74 L 12 74 Z" fill="#CBD5E0" />
        </g>

        {/* --- Swiss Cheese Slice (Center) --- */}
        <g id="cheese-slice">
            {/* Triangle Cheese with Bite Indents */}
            <path
                d="M 33 74 
                   C 32 72, 34 71, 34 69 
                   C 34 67, 32 66, 32 64 
                   L 36 54 
                   C 36 52, 38 51, 38 49 
                   C 38 47, 36 46, 36 45 
                   L 44 45 
                   L 58 74 Z"
                fill="#ECC94B"
            />
            {/* Swiss Cheese Holes */}
            <circle cx="45" cy="62" r="3" fill="#D69E2E" />
            <circle cx="39" cy="71" r="2.5" fill="#D69E2E" />
            <circle cx="49" cy="70" r="3.5" fill="#D69E2E" />
            <circle cx="44" cy="53" r="2" fill="#D69E2E" />
        </g>

        {/* --- Yogurt / Drink Cup (Front Right) --- */}
        <g id="yogurt-cup">
            {/* Green Cup Body */}
            <polygon points="50,58 72,58 68,79 54,79" fill="#48BB78" />
            
            {/* Rim */}
            <rect x="49" y="57" width="24" height="2.5" rx="1" fill="#38A169" />
            
            {/* Gloss Reflections */}
            <circle cx="55" cy="63" r="2" fill="#FFFFFF" opacity="0.6" />
            <circle cx="58" cy="67" r="1.2" fill="#FFFFFF" opacity="0.6" />
        </g>
    </svg>
);

export default GroceryIcon;
